export const visitPurposes = [
  {
    id: '0',
    value: 0,
    label: 'タカラッシュ！公式ホームページ',
  },
  {
    id: '1',
    value: 1,
    label: 'タカラッシュ！のSNS・メルマガ',
  },
  {
    id: '2',
    value: 2,
    label: 'LINE広告',
  },
  {
    id: '3',
    value: 3,
    label: 'Youtube広告を見て',
  },
  {
    id: '4',
    value: 4,
    label: '知人・友人に教えてもらって',
  },
  {
    id: '5',
    value: 5,
    label: 'のぼり・ポスター',
  },
  {
    id: '6',
    value: 6,
    label: '参加チラシを見て',
  },
  {
    id: '7',
    value: 7,
    label: '学校での配布',
  },
  {
    id: '8',
    value: 8,
    label: '福島県広報ホームページ',
  },
  {
    id: '99',
    value: 99,
    label: 'その他',
  },
] as const;
